// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__Ilc4k","mark":"Sidebar_mark__l8STK","content":"Sidebar_content__374D-","resume":"Sidebar_resume__oaF+u"};